/// <reference path="../ProjectFinder2/ProjectFinderHomeLM.ts" />
import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../EmploymentFinder/EmploymentFinderHomeTypes";
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import { EntityHelpers } from "../../more/Helpers";
import { OMtypes } from "../_loadingHelpers/OM";

class OpusPerformanceAgenda extends compose(AgendaViewBase<any>, _TabEnabledMixin) {
	//templateString = template; // Standard verwenden...

    buttonClickTimeout: number = null;

    //private tableFormatter(cell: StaticTable.StaticTableCell<Types.EvBooking>) {
    //    let node = cell.contentnode;
    //    let entity = cell.entity;
    //    let colName = cell.name;
    //    let value = cell.value;
    //    switch (colName) {
    //        case "date":
    //            let dateFrom = entity.date_start;
    //            let dateTo = entity.date_end;

    //            node.innerHTML = this.dateToString(entity.date_start, "dd.MM.yyyy HH:mm") + " - " + this.dateToString(entity.date_end, "dd.MM.yyyy HH:mm");
    //            break;
    //        default:
    //            node.innerHTML = value;
    //    }
    //}

    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string) {
        if (this.hasFeature("EvBooking/XXXXXXX")) {
            
        }
    }

   

    openDetailView(row: StaticTable.StaticTableRow<OMtypes.orchestraEmployment>, rowGroup: StaticTable.StaticTableRowGroup<OMtypes.orchestraEmployment>) { 

        let entity = rowGroup.entity;

        EntityHelpers.openEntityView({
            entityClass: rowGroup.entity?.Classname,
            entityId: rowGroup.entity?.ID,
            label: rowGroup.entity.gDisp_1,
            contextName: "opusperformance"
        })

    }
   
    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this.setupAgendaViewWithCallfunction(
            "Webtool_API_OpusPerformance__GetEmploymentsAgendaConfig",
            "Webtool_API_OpusPerformance__GetEmploymentsAgendaResult",
            lang.hitch(this, this.openDetailView),
            null, // Standard-Formatter
            null
        );

    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(OpusPerformanceAgenda);